import { render, staticRenderFns } from "./TableMedia.vue?vue&type=template&id=9f1a1d70&"
import script from "./TableMedia.vue?vue&type=script&lang=js&"
export * from "./TableMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports